<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-tabs
          v-model="activeTab"
          type="card"
          @tab-click="changeTabFun()"
        >
          <el-tab-pane
            label="零售户档案信息"
            name="archives"
          >
            <el-form
              ref="dialogViewForm"
              :model="dialogViewForm"
            >
              <div class="modal-box">
                <h3 class="modal-title">
                  基础信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="店名(专卖证)">
                        <el-input
                          v-model="dialogViewForm.storeName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="地址(专卖证)">
                        <el-input
                          v-model="dialogViewForm.address"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="实际店名">
                        <el-input
                          v-model="dialogViewForm.realStoreName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="实际地址">
                        <el-input
                          v-model="dialogViewForm.realAddress"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="所属省区">
                        <el-input
                          v-model="dialogViewForm.provinceName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="所属城市">
                        <el-input
                          v-model="dialogViewForm.cityName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="所属区县">
                        <el-input
                          v-model="dialogViewForm.countyName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="专卖证号">
                        <el-input
                          v-model="dialogViewForm.certificateNo"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="档位">
                        <el-input
                          v-model="dialogViewForm.levelStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="店铺业态">
                        <el-input
                          v-model="dialogViewForm.storeTypeStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="卷烟经营">
                        <el-input
                          v-model="dialogViewForm.cigaretteBusinessStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="商圈">
                        <el-input
                          v-model="dialogViewForm.businessDistrictName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="维护人">
                        <el-input
                          v-model="dialogViewForm.manageUserName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="零售户类型">
                        <el-input
                          v-model="dialogViewForm.storeSortStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="应用分类">
                        <el-input
                          v-model="dialogViewForm.terminalTypeNames"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="零售户标签">
                        <el-input
                          v-model="dialogViewForm.storeTagNames"
                          type="textarea"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="modal-box">
                <h3 class="modal-title">
                  联系信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="店主姓名">
                        <el-input
                          v-model="dialogViewForm.ownerName"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="性别">
                        <el-input
                          v-model="dialogViewForm.genderStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="联系电话">
                        <el-input
                          v-model="dialogViewForm.phone"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="本香注册号码">
                        <el-input
                          v-model="dialogViewForm.benxiangNo"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="联系人1">
                        <el-input
                          v-model="dialogViewForm.linkman1"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="联系人1与店主关系">
                        <el-input
                          v-model="dialogViewForm.linkman1Relation"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="联系人1电话">
                        <el-input
                          v-model="dialogViewForm.linkman1Phone"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="本香门店编码">
                        <el-input
                          v-model="dialogViewForm.benxiangStoreNo"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="联系人2">
                        <el-input
                          v-model="dialogViewForm.linkman2"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="联系人2与店主关系">
                        <el-input
                          v-model="dialogViewForm.linkman2Relation"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="联系人2电话">
                        <el-input
                          v-model="dialogViewForm.linkman2Phone"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="modal-box">
                <h3 class="modal-title">
                  店面形象信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="总背柜组数">
                        <el-input
                          v-model="dialogViewForm.totalBackCabinetGroupNum"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="总背柜格数">
                        <el-input
                          v-model="dialogViewForm.totalBackCabinetGridNum"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="总地柜组数">
                        <el-input
                          v-model="dialogViewForm.totalFloorCabinetGroupNum"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="店面面积">
                        <el-input
                          v-model="dialogViewForm.storeAreaStr"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="modal-box">
                <h3 class="modal-title">
                  备注信息
                </h3>
                <div class="modal-row-box">
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-form-item prop="remark">
                        <el-input
                          v-model="dialogViewForm.remark"
                          type="textarea"
                          placeholder="备注"
                          style="margin-top:10px;"
                          disabled
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane
            label="新品动销"
            name="surveyInfo"
          >
            <div class="modal-box">
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-select
                      v-model="singleSearch.productId"
                      filterable
                      clearable
                      placeholder="请选择品规"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in singleProductOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-date-picker
                      v-model="singleSearch.searchStartDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择开始日期"
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-date-picker
                      v-model="singleSearch.searchEndDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择结束日期"
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-button @click="searchSurveyInfoFun">
                      查询
                    </el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <view-table
                    :table-columns="singleTableColumns"
                    :table-data="singleListData"
                    table-custom-height="480"
                  />
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="云产烟经营情况"
            name="retailSurveyInfo"
          >
            <div class="modal-box">
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-date-picker
                      v-model="retailInfoSearch.searchStartDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择开始日期"
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-date-picker
                      v-model="retailInfoSearch.searchEndDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择结束日期"
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-button @click="searchRetailSurveyInfoFun">
                      查询
                    </el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <view-table
                    :table-columns="retailSurveyTableColumns"
                    :table-data="retailSurveyListData"
                    table-custom-height="480"
                  />
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="重点品规动销"
            name="retailSurveyItem"
          >
            <div class="modal-box">
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-input
                      v-model="retailItemSearch.productName"
                      placeholder="输入品规"
                      clearable
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-date-picker
                      v-model="retailItemSearch.searchStartDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择开始日期"
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-date-picker
                      v-model="retailItemSearch.searchEndDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择结束日期"
                    />
                  </el-col>
                  <el-col
                    :span="4"
                    class="search-col"
                  >
                    <el-button @click="searchRetailSurveyItemFun">
                      查询
                    </el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <view-table
                    :table-columns="retailItemTableColumns"
                    :table-data="retailItemListData"
                    table-custom-height="480"
                  />
                </el-row>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import viewTable from '@/components/viewTable'
// 数据请求
import { initStoreApi } from '@/api/store'
import { findSurveyProductInfoByConditionApi } from '@/api/surveyProductSetting'
import { findRetailSurveyInfoByConditionApi, findRetailSurveyItemByConditionApi } from '@/api/retailSurveyInfo'
// API
import { listSurveyProductSettingApi } from '@/api/v2/surveyProductSetting'

export default {
  components: { viewTable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogViewForm: {
      },
      dialogAddEditViewForm: {
      },
      activeTab: '',
      //单品采集
      singleSearch: {
        productId: '',
        searchStartDate: '',
        searchEndDate: '',
        orderCondition: 'order by survey_date desc'
      },
      singleProductOptions: [],
      singleTableColumns: [
        { label: '采集时间', prop: 'surveyDateStr', width: 110 },
        { label: '采集人', prop: 'surveyUser', width: 100 },
        { label: '采集品规', prop: 'productName', width: 120 },
        { label: '到货时间', prop: 'orderDateStr', width: 100 },
        { label: '到货条量', prop: 'orderAmount', width: 100 },
        { label: '当前库存(包)', prop: 'inventoryAmount', width: 120 },
        { label: '包零售价', prop: 'packagePrice', width: 100 },
        { label: '条零售价', prop: 'orderPrice', width: 100 },
        { label: '集市交易条价格', prop: 'marketPrice', width: 120 },
        { label: '周动销情况', prop: 'dynamicSalesStr', width: 100 },
        { label: '意见建议', prop: 'opinionStr', width: 100 },
        { label: '是否采集完成', prop: 'isCompleteStr', width: 120 },
        { label: '未完成原因', prop: 'noCollectReasonStr', width: 110 }
      ],
      singleListData: [],
      // 零售监测总表
      retailInfoSearch: {
        searchStartDate: '',
        searchEndDate: '',
        orderCondition: 'order by collection_date desc'
      },
      retailSurveyTableColumns: [
        { label: '采集时间', prop: 'collectionDateStr', width: 110 },
        { label: '采集人', prop: 'collectionUserName', width: 100 },
        { label: '采集方式', prop: 'collectionTypeStr', width: 80 },
        { label: '是否采集', prop: 'isCollectStr', width: 80 },
        { label: '未采集原因', prop: 'noCollectReasonStr' },
        { label: '本周总销售(条)', prop: 'weekSalesAmount', width: 120 },
        { label: '当前总库存(条)', prop: 'inventoryAmount', width: 120 },
        { label: '云产烟总销售(条)', prop: 'yunWeekSalesAmount', width: 130 },
        { label: '云产烟总库存(条)', prop: 'yunInventoryAmount', width: 130 }
      ],
      retailSurveyListData: [],
      // 零售监测明细表
      retailItemSearch: {
        productName: '',
        searchStartDate: '',
        searchEndDate: '',
        orderCondition: 'order by i.collection_date desc'
      },
      retailItemTableColumns: [
        { label: '采集时间', prop: 'collectionDateStr', width: 110 },
        { label: '采集人', prop: 'collectionUserName', width: 100 },
        { label: '采集品规', prop: 'productName' },
        { label: '是否采集', prop: 'isCompleteStr', width: 80 },
        { label: '未采集原因', prop: 'noCollectReasonStr', width: 120 },
        { label: '本周期到货(条)', prop: 'orderAmount', width: 120 },
        { label: '当前库存(条)', prop: 'inventoryAmount', width: 120 },
        { label: '本码出货价', prop: 'codeSalesPrice', width: 110 }
      ],
      retailItemListData: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.activeTab = 'archives'
        this.singleSearch = {
          productId: '',
          searchStartDate: '',
          searchEndDate: '',
          orderCondition: 'order by survey_date desc'
        }
        this.singleProductOptions = []
        this.singleListData = []
        this.retailInfoSearch = {
          searchStartDate: '',
          searchEndDate: '',
          orderCondition: 'order by collection_date desc'
        }
        this.retailSurveyListData = []
        this.retailItemSearch = {
          productName: '',
          searchStartDate: '',
          searchEndDate: '',
          orderCondition: 'order by i.collection_date desc'
        }
        this.retailItemListData = []
        this.dialogViewForm = {
          storeName: '',
          address: '',
          realStoreName: '',
          realAddress: '',
          provinceName: '',
          cityName: '',
          countyName: '',
          certificateNo: '',
          levelStr: '',
          storeTypeStr: '',
          cigaretteBusinessStr: '',
          businessDistrictName: '',
          manageUserName: '',
          storeSortStr: '',
          terminalTypeNames: '',
          storeTagNames: '',
          ownerName: '',
          genderStr: '',
          phone: '',
          linkman1: '',
          linkman1Relation: '',
          linkman1Phone: '',
          linkman2: '',
          linkman2Relation: '',
          linkman2Phone: '',
          benxiangNo: '',
          benxiangStoreNo: '',
          totalBackCabinetGroupNum: 0,
          totalBackCabinetGridNum: 0,
          totalFloorCabinetGroupNum: 0,
          storeAreaStr: '',
          remark: '',
          lat: null,
          lng: null
        }
        this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData () {
      initStoreApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogViewForm) {
          this.dialogViewForm[key] = data[key]
        }
        this.dialogViewForm.id = data.id
        this.singleSearch.storeId = data.id
        this.retailInfoSearch.storeId = data.id
        this.retailItemSearch.storeId = data.id
        this.initSingleProductFun(data)
        this.searchSurveyInfoFun()
        this.searchRetailSurveyInfoFun()
        this.searchRetailSurveyItemFun()
        this.loading = false
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    changeTabFun () {
      console.log(this.activeTab)
    },
    // 初始化单品品规
    initSingleProductFun (store) {
      let _this = this
      listSurveyProductSettingApi({ status: 1, cityId: store.cityId }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.singleProductOptions.push({ label: item.name, data: item.id, priceRangeId: 0 })
        })
      })
    },
    // 查询单品动销监测数据
    searchSurveyInfoFun () {
      this.singleListData = []
      this.loading = true
      findSurveyProductInfoByConditionApi(this.singleSearch).then(res => {
        this.singleListData = res.data
        this.loading = false
      })
    },
    // 查询零售监测总表数据
    searchRetailSurveyInfoFun () {
      this.retailSurveyListData = []
      this.loading = true
      findRetailSurveyInfoByConditionApi(this.retailInfoSearch).then(res => {
        this.retailSurveyListData = res.data
        this.loading = false
      })
    },
    // 查询零售监测明细表数据
    searchRetailSurveyItemFun () {
      this.retailItemListData = []
      this.loading = true
      findRetailSurveyItemByConditionApi(this.retailItemSearch).then(res => {
        this.retailItemListData = res.data
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
.mapClass {
  width: 1060px;
  height: 540px;
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
.search-col {
  padding-top: 5px;
  min-height: 40px;
}
</style>
